import type { ReactNode } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "@remix-run/react";
import ReactModal from "react-modal";
import { classNames } from "~/utils";

type ModalProps = {
  title?: string;
  subtile?: string;
  open: boolean;
  setOpen?: (open: boolean) => void;
  hasIcon?: boolean;
  children?: ReactNode;
  type?: "success" | "warning";
  planDialgo?: boolean;
};
export default function Modal({
  title,
  // subtile,
  open,
  setOpen,
  // hasIcon = false,
  // type = "success",
  children,
  planDialgo,
}: // planDialgo = false,
ModalProps) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const handleCloseModal = () => {
    if (typeof setOpen === "function") {
      setOpen(false);
    }
    if (search.includes("openmoldal")) {
      navigate(pathname);
    }

    //this navigate(pathname); to override openmoldal=1 in the url in the case where the user comes from the start page.
  };
  return (
    <ReactModal
      shouldCloseOnOverlayClick
      // preventScroll={false}
      isOpen={open}
      ariaHideApp={false}
      onRequestClose={handleCloseModal}
      // role="div"
      // keepMounted
      //@ts-ignore
      // parentSelector={() => document.querySelector("#main_filter")}
      contentLabel={title}
      htmlOpenClassName="ReactModal__inklusion--open"
      className="mx-auto h-full w-full max-w-9xl"
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.85)",
          // opacity: 0.8,
        },
        content: {
          border: "1px solid transparent",
          overflow: "hidden",
          backgroundColor: "transparent",
          WebkitOverflowScrolling: "touch",
          borderRadius: "0",
          outline: "none",
          // padding: "20px",
        },
      }}
    >
      <div
        className="fixed inset-0 overflow-hidden bg-transparent"
        onClick={handleCloseModal}
        role="presentation"
        aria-hidden="true"
      />
      {!planDialgo ? (
        <>
          <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0 lg:px-4 lg:pt-10">
            <div
              style={{
                background:
                  "linear-gradient(0deg, rgba(250,252,252,1) 0%, rgba(252,244,214,1) 100%)",
                // border-radius: '16px',
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                backdropFilter: "blur(12.3px)",
                border: "rgba(254, 250, 179, 0.06)",
              }}
              className={classNames(
                "relative flex h-auto w-full transform flex-col rounded-lg pt-5 pb-4 text-left shadow-xl transition-all sm:mt-8",
                planDialgo ? "md:max-w-[990px]" : ""
              )}
            >
              <div className="flex justify-between">
                <div className="flex items-baseline justify-between  pb-6 sm:px-6 lg:px-20">
                  <h1 className="text-2xl font-bold tracking-tight text-textColor-light">
                    {title}
                  </h1>
                </div>

                <div
                  className={classNames(
                    "pr-5 sm:block",
                    title ? "lg:pr-20" : "lg:pr-10"
                  )}
                >
                  <button
                    type="button"
                    className="z-10 flex w-full rounded-full bg-black
           text-white hover:text-secondary
           focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    onClick={() => handleCloseModal()}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-7 w-7" aria-hidden="true" />
                  </button>
                </div>
              </div>
              {title && (
                <div className="mx-20 h-[1px] bg-default opacity-10"></div>
              )}
              <div className="flex h-full flex-col py-4">{children}</div>
            </div>
          </div>
        </>
      ) : (
        children
      )}
    </ReactModal>
  );
}
